<div class="general-container">
  <h3 class="font-sans text-2xl">{{ 'invest.Reserved.Title' | translate }}</h3>
  <div class="header-text">
      <p *ngIf="totalInversoresActual > 0" class="font-sans text-l text-eggplant-80">{{ 'invest.Reserved.Current' | translate }} <span class="money text-eggplant-100 font-sansMedium">{{ totalInversoresActual }}</span> {{ userN }} {{ 'invest.Reserved.Confirm' | translate }}
          <span class="money text-eggplant-100 font-sansMedium">{{ totalMoneyReserved | number:'1.0-0':'es' }} €</span>. </p>
      <p *ngIf="totalInversoresActual === 0" class="font-sans text-l text-eggplant-80">{{ 'invest.Reserved.no-investors' | translate }}</p>
      <p *ngIf="btnType === 'primaryDark-disabled'" class="font-sans text-l text-eggplant-80">{{ 'invest.Reserved.Stay' | translate }}</p>
      <p *ngIf="btnType === 'primaryDark'" class="font-sans text-l text-eggplant-80">{{ 'invest.Reserved.Continue' | translate }}</p>
  </div>
  <div class="tables">
      <div *ngIf="reservedData.length > 0" class="table-header">
          <p class="font-sans text-l text-eggplant-70 uppercase">{{ 'invest.Reserved.expire_in' | translate }}</p>
          <p class="font-sans text-l text-eggplant-70 uppercase">{{ 'invest.Reserved.money' | translate }}</p>
      </div>
      <div *ngFor="let data of reservedData" class="reserved-data">
          <p class="time-r font-sans text-l text-eggplant-80">{{ data.timeR }}</p>
          <p class="amount font-sans text-l text-eggplant-80">{{ data.amount | localeNumber }} €</p>
      </div>
  </div>
  <div class="btn-container row">
      <div class="col-6">
          <fun-new-button [buttonType]="'secondaryDark'" title="{{ 'BIOMETRIC.CANCEL' | translate }}" (eventClick)="cancel()"></fun-new-button>
      </div>
      <div class="col-6">
          <fun-new-button *ngIf="btnType === 'primaryDark-disabled'" [buttonType]="btnType"
          title="{{ totalMoneyReserved | number:'1.0-0':'es' }} € {{ 'INVEST.RESERVED' | translate }}"></fun-new-button>
          <fun-new-button *ngIf="btnType === 'primaryDark'" [buttonType]="btnType"
          title="{{ freeToInvest | number:'1.0-0':'es' }} € {{ 'INVEST.AVAILABLES' | translate }}" (eventClick)="continue()"></fun-new-button>
      </div>
  </div>
</div>
